import { useQueryClient } from '@tanstack/react-query'

import { useQuery } from '../../lib/react-query/useQuery.js'
import { getChatsReadOffsetsKey } from '../../utils/keys/messaging.key.js'

type ChatsReadOffset = Record<string, number>

export const useChatsReadOffset = () => {
  const chatsReadOffsetsKey = getChatsReadOffsetsKey()
  const queryClient = useQueryClient()

  const { data: chatsReadOffsets } = useQuery<ChatsReadOffset>(
    chatsReadOffsetsKey,
    () => queryClient.getQueryData<ChatsReadOffset>(chatsReadOffsetsKey),
    {
      initialData: {},
    },
  )

  const setChatReadOffset = (chatId: string, readOffset: number) => {
    queryClient.setQueryData<ChatsReadOffset>(chatsReadOffsetsKey, {
      ...chatsReadOffsets,
      [chatId]: readOffset,
    })
  }

  return {
    chatsReadOffsets,
    setChatReadOffset,
  }
}
